import { match } from 'ts-pattern';
import noop from 'utils/noop';

import {
  DragAndDropEditorModalType,
  useDragAndDropEditorModalsContext,
} from 'modules/dragAndDropEditor/context';
import { ConfirmationPrompt, ModalConfirmationFooterProps } from 'ui/modal';
import {
  CategoryFieldToDelete,
  ManageCustomCategoriesConfirmationType,
} from '../ManageCustomCategoriesModal.types';

export type UseManageCustomCategoriesFooterTypePropsOptions = {
  categoryToDelete?: CategoryFieldToDelete;
  manageCustomCategoriesConfirmationType: ManageCustomCategoriesConfirmationType;
  processCategoryDeletion: () => void;
  onCloseCallback: () => void;
};

export const useManageCustomCategoriesFooterTypeProps = ({
  onCloseCallback = noop,
  processCategoryDeletion = noop,
  categoryToDelete,
  manageCustomCategoriesConfirmationType,
}: UseManageCustomCategoriesFooterTypePropsOptions): Partial<ModalConfirmationFooterProps> => {
  const { closeModal } = useDragAndDropEditorModalsContext();

  return match(manageCustomCategoriesConfirmationType)
    .with(ManageCustomCategoriesConfirmationType.DeleteCategory, () => ({
      discardLabel: `Delete${categoryToDelete?.name ? ` ${categoryToDelete.name}` : ''} category?`,
      resumeButtonLabel: 'Keep editing',
      discardButtonLabel: 'Delete category',
      discardHelpText: 'Rows will still be available in All saved rows category.',
      promptType: ConfirmationPrompt.DISCARD,
      onDiscard: processCategoryDeletion,
    }))
    .with(ManageCustomCategoriesConfirmationType.UnsavedChanges, () => ({
      discardLabel: 'Discard changes?',
      resumeButtonLabel: 'Keep editing',
      discardButtonLabel: 'Close and discard',
      discardHelpText: 'You will lose unsaved changes.',
      promptType: ConfirmationPrompt.DISCARD,
      onDiscard: () => {
        onCloseCallback();
        closeModal(DragAndDropEditorModalType.ManageCustomCategories);
      },
    }))
    .otherwise(() => ({ promptType: ConfirmationPrompt.NONE }));
};
